import type { EmbedHtmlModel } from '@blocksuite/affine-model';

import { BlockService } from '@blocksuite/block-std';

export class EmbedHtmlBlockService extends BlockService<EmbedHtmlModel> {}
